import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_PRICE_COLLECTION_NAME = "price";

export const useRxCollectionPrice = (): RxCollection<Price> | null =>
  useRxCollection<Price>(RXDB_PRICE_COLLECTION_NAME);

type UseRxData = Parameters<typeof useRxData<Price>>;
export type PriceQueryConstructor = UseRxData["1"];

const PRICE_SCHEMA_LITERAL = {
  title: "price schema",
  version: 1,
  description: "A price tied to a (priceList, item, tariff) tuple",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    value: {
      type: "integer",
    },
    priceListId: {
      type: "string",
      maxLength: 100,
    },
    itemId: {
      type: "string",
      maxLength: 100,
    },
    tariffId: {
      type: "string",
      maxLength: 100,
    },
    revenueDepartmentId: {
      type: "string",
      maxLength: 100,
    },
    meta: SYNCABLE_META,
  },
  required: [
    "id",
    "value",
    "priceListId",
    "itemId",
    "tariffId",
    "revenueDepartmentId",
    "meta",
  ],
  indexes: ["priceListId", ["priceListId", "itemId", "tariffId"]],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(PRICE_SCHEMA_LITERAL);

export type Price = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const PRICE_SCHEMA: RxJsonSchema<Price> = PRICE_SCHEMA_LITERAL;
